import { render, staticRenderFns } from "./ModalVisualizarDetalhesAlerta.vue?vue&type=template&id=b9e12af2&scoped=true&lang=pug"
import script from "./ModalVisualizarDetalhesAlerta.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarDetalhesAlerta.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarDetalhesAlerta.vue?vue&type=style&index=0&id=b9e12af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e12af2",
  null
  
)

export default component.exports